import { render, staticRenderFns } from "./AssetNew.vue?vue&type=template&id=b6be7246&scoped=true&"
import script from "./AssetNew.vue?vue&type=script&lang=js&"
export * from "./AssetNew.vue?vue&type=script&lang=js&"
import style0 from "./AssetNew.vue?vue&type=style&index=0&id=b6be7246&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6be7246",
  null
  
)

export default component.exports